import React from 'react';
import PropTypes from 'prop-types';
import {
	WIDGET_LOADED,
	WIDGET_LOADING,
	WIDGET_HIDDEN
} from '../actions/widgetStates';
import Loaded from './views/Loaded';
import Error from './views/Error';
import NotLoaded from './views/NotLoaded';
import Hidden from './views/Hidden';

class WidgetDisplay extends React.Component {
	render() {
		let currentView;

		switch (this.props.widgetState.state) {
			case WIDGET_HIDDEN:
				currentView = <Hidden />;
				break;
			case WIDGET_LOADED:
				currentView = <Loaded />;
				break;
			case WIDGET_LOADING:
				currentView = <NotLoaded />;
				break;
			default:
				currentView = <Error />;
		}

		return <div className="viewContainer">{currentView}</div>;
	}
}

WidgetDisplay.propTypes = {
	widgetState: PropTypes.shape({
		state: PropTypes.string,
		nextState: PropTypes.arrayOf(PropTypes.string)
	}).isRequired
};

export default WidgetDisplay;



// WEBPACK FOOTER //
// ./src/components/WidgetDisplay.jsx